export const WEAK_PASSWORD_ERROR_MESSAGE = "This password is too weak and isn't allowed. Choose a stronger password that isn't commonly used to help keep your account secure.";
export const sameDayCollectionMessage = 'For collection today your gift will be ready 1 hour 30 minutes after we’ve received the order';
export const futureDayCollectionMessage = 'Your gift will be made fresh on the day you have selected, please collect your gift 1 hour 30 minutes after the shop is open.';
export const oldCustomerAlertMessageFF = 'Uh oh, looks like you’ve already ordered with us so you can’t use this code. Sorry!';
export const oldCustomerAlertMessageUK = 'Sorry it looks like you’ve ordered with us before, so you can’t use this code.';
export const signInRegisterAlertMessageFF = 'To snag your first order discount, please';
export const signInRegisterAlertMessageUK = 'To get your first order discount please';
export const REGISTER_REASONS_FF = ['Address book setup to make your next order as easy as possible.'];
export const getRegisterReasonsUKIE = (currencySymbol) => [
    'Easy order tracking',
    `Set up occasion reminders. You'll get an email nudge (and ${currencySymbol}5 discount!) just before the date.`,
    'Save your addresses',
    'Access to delivery passes for great savings on delivery costs',
];
export const invalidPromoCodeAlertMessage = 'The promotional code you entered is not valid.';
export const promotionalCodeApplyError = 'There has been an error applying the promotional code, please try again.';
export const emailSubject = 'Problem changing privacy settings';
export const privacySuccessMessage = 'Your privacy settings have been saved.';
export const privacyErrorMessage = 'There was a problem. Please contact us at';
export const deliveryInstructionNote = 'Please be patient, untill i open the door';
export const deliveryInstructionOption = 'Please be patient';
export const deliveryInstructionOptionNotToshow = 'Press to select';
export const deliveryInstructionLable = 'Delivery instructions';
export const ERROR_TOWN_LIST_PREFIX = 'Error retrieving a list of towns for';
export const ERROR_COUNTY_LIST_PREFIX = 'Error retrieving a list of counties for';
export const FLORISTS_NEAR_YOU = 'Florists near';
export const CHANGE_FLORIST = 'Change florist';
export const START_NEW_SEARCH = 'Start new search';
export const SEARCH_NEW_ADDRESS = 'Search new address';
export const LOAD_MORE_FLORISTS = 'Load more florists';
export const SELECT_FLORIST = 'Select florist';
export const OCCASION_REQUIRED_MESSAGE = 'Please select an occasion';
export const DELIVERY_INSTRUCTION_LINK = 'Want to add extra delivery instructions?';
export const DAYPICKER_ERROR_MESSAGE = 'Select a delivery date';
export const EMPTY_BASKET_TITLE = 'Basket';
export const EMPTY_BASKET_MESSAGE = 'Your basket is empty.';
export const EMPTY_BASKET_BUTTON_TITLE = 'Browse all categories';
export const EMPTY_BASKET_HREF_FF = '/category/all-flower-bouquets';
export const EMPTY_BASKET_HREF_UK_IE = '/category/occasion-flowers';
export const CHOOSE_DATE = 'Choose a date';
export const CHOOSE_ADDRESS = 'Choose a delivery address';
export const CHOOSE_AN_OCCASION = 'Choose an occasion';
export const INTERNATIONAL_DELIVERY = 'International delivery';
export const ENTER_DELIVERY_ADDRESS = 'Enter delivery address';
export const RECIPIENT_ADDRESS = 'Recipient address';
export const LIST_VIEW = 'List View';
export const MAP_VIEW = 'Map View';
export const RECOMMENDED = 'Recommended';
export const OUR_FAVOURITES = 'Our favourites';
export const READ_TIME = 'Read time - {count} mins';
export const READ_MORE = 'Read more';
export const READ_LESS = 'Read less';
export const collectionInstructionsTitle = 'Collection instructions';
export const collectionText = 'The florist will need a minimum of 1 hour 30 minutes to prepare your flowers, but you can specify a preferred collection time below';
export const collectionInstructionPlaceholder = 'For example...\n1.30pm (in my lunch break)';
export const OCCASION_PERSONALISED_MESSAGES = {
    "Mother's Day": 'Happy Mother’s Day.\n\nLots of love,',
    Birthday: 'Happy birthday! Hope you have a brilliant day.',
    Friendship: 'Thanks for being an amazing friend.',
    Sympathy: 'I’m so sorry, sending all my love.',
    'Thinking of You': 'Thinking of you and sending love.',
    'Thank You': 'Thank you so much for everything!',
    Anniversary: 'Happy anniversary to my special someone.',
    "Valentine's Day": 'Be my Valentine – now, next year, and every year to come.',
};
export const PDP_COLLECTION_STEP_2_TITLE = 'Would you like your order delivered?';
export const PDP_DELIVERY_STEP_2_TITLE = 'Who is this gift for?';
export const PRODUCTDETAIL = 'ProductDetail';
export const standardDeliveryType = 'Delivery';
export const collectionDeliveryType = 'Collection';
export const COLLECT_FROM_FLORIST = 'Collect from florist';
export const deliveryTypes = [
    { title: 'Delivery', icon: 'local_shipping', description: 'by local florist', cta_label: 'Next: Delivery date' },
    { title: 'Collection', icon: 'store', description: 'from local florist', cta_label: 'Next: Collection date' },
];
export const CTA_ADDRESS_FF = 'Next: Delivery date';
export const CTA_ADDRESS_IF_MOBILE = 'Next';
export const CONTINUE_PERSONALISE_YOUR_GIFT = 'Continue and personalise your gift';
export const RECIPIENT_DETAILS = '1. Recipient Details';
export const PERSONALISE = '2. Personalise';
export const FREE_LABEL = 'FREE';
export const ADDRESS_PLACEHOLDER_EIRCODE = 'Try the eircode or street name';
export const ADDRESS_PLACEHOLDER_COLLECTION = 'Enter town or postcode';
export const ADDRESS_PLACEHOLDER_COLLECTION_IE = 'Try the town or eircode';
export const ADDRESS_PLACEHOLDER_DELIVERY = 'Enter delivery postcode';
export const PDP_COLLECTION_STEP_3_TITLE = 'When and where would you like to collect your gift?';
export const PDP_FF_DELIVERY_STEP_3_TITLE = 'Choose a delivery date';
export const PDP_DROPSHIP_STEP_3_TITLE = 'When would you like your gift to be delivered?';
export const PDP_STEP_3_TITLE = 'When would you like your gift?';
export const DELIVERY_OPTION_TITLE = 'Select a delivery option for';
export const COLLECTION_OPTION_TITLE = 'Collect from florist on';
export const COLLECTION_ADDRESS_LABEL = 'Search for collection address';
export const COLLECTION_ADDRESS_PLACEHOLDER = 'Search for town';
export const COLLECTION_ADDRESS_REQUIRED_MESSAGE = 'Please select an address from the list';
export const COUNTRY_REQUIRED_ERROR_MESSAGE = 'Please select a country';
export const COLLECTION_AVAILABILITY_ERROR_MESSAGE = 'The collection availability check returned an error response:';
export const UNAVAILABLE_MODAL_TITLE = 'We can’t quite do that';
export const COLLECTION_UNAVAILABLE_MODAL_DESCRIPTION = `We're really sorry, but you can’t collect the `;
export const COLLECTION_UNAVAILABLE_MODAL_DESCRIPTION_2 = 'from that location on that day.';
export const COLLECTION_UNAVAILABLE_MODAL_SUB_DESCRIPTION = 'Choose one of the following instead:';
export const CHOOSE_DELIVERY_OPTION = 'Choose a delivery option';
export const CHANGE_COLLECTION_ADDRESS = 'Change collection address';
export const CHANGE_DELIVERY_DATE = 'Choose a different date';
export const STEM_SPECIFIC_PRICING = {
    displayText: 'Choose number of ',
    descriptionText: 'Same day delivery available for up to ',
};
export const SPECIAL_INSTRUCTIONS_TITLE = 'Do you have any special requests?';
export const STEMS_SPECIFIC_TITLE = 'How many {stems} would you like?';
export const VARIANT_TITLE = 'What {variant} would you like?';
export const VARIANT_TITLE_TEXT = `Choose your {titleVariant}`;
export const NO_SPECIAL_INSTRUCTIONS_LABEL = '(No special request entered)';
export const FROM = 'From';
export const PURCHASE_VARIANT_BUTTON_TITLES = {
    DEFAULT: 'Who this gift is for',
    ALTERNATE_FLOW: 'Buy now',
    FLYING_FLOWERS: 'Delivery address',
    FUNERAL: 'Who this tribute is for',
    ALTERNATE_FLOW_FLYING_FLOWERS: 'Add to basket',
};
export const VIEW_AVAILABLE_GIFTS = 'View available gifts';
export const VIEW_SUITABLE_GIFTS = 'View suitable gifts';
export const SAVE_OCCASION = 'Save occasion';
export const PCC_EDIT_TRACKING_LOCATION = {
    1: 'date',
    2: 'address',
    3: 'occasion',
};
export const COLLECTION_DETAILS_TITLES = {
    selectedFloristShop: 'Your selected florist shop:',
    collectionFrom: 'Collection From:',
    collectFromFlorist: 'Collect from florist',
    emailNotification: 'You’ll be sent an email when it’s ready to collect',
};
export const PRODUCT_QUERY_PARAMS = 'productQueryParams';
export const INTERNATIONAL = 'international';
export const PRODUCT_PATH_PREFIX = '/product/';
export const CATEGORY_PATH_PREFIX = '/category/';
// UK2IE / IE2UK ("overseas") products are published under a '-int' suffixed slug by the API's
// CommercetoolsTransformer, which is what separates them from general International products.
export const OVERSEAS_PRODUCT_SLUG_SUFFIX = '-int';
export const PDP_ALTERNATE_FLOW_ATTRIBUTE = 'data-pdp-alternate-flow';
export const PDP_ALTERNATE_FLOW_SELECTOR = `[${PDP_ALTERNATE_FLOW_ATTRIBUTE}="true"]`;
export const PDP_REDESIGN_ATTRIBUTE = 'data-pdp-redesign';
export const PDP_REDESIGN_SELECTOR = `[${PDP_REDESIGN_ATTRIBUTE}="true"]`;
export const HOME_HERO_BLOG_ATTRIBUTE = 'data-home-hero-blog';
export const HOME_HERO_BLOG_SELECTOR = `[${HOME_HERO_BLOG_ATTRIBUTE}="true"]`;
export const INTERNATIONAL_DROPDOWN_TITLE = 'Where would you like delivery to?';
export const PLEASE_SELECT = 'Please select';
export const DELIVERY_UNAVAILABLE_PRODUCTS_UNAVAILABLE_MODAL = {
    modalTitle: 'Delivery unavailable',
    productContent: 'Unfortunately, we are unable to deliver any gifts to your requirements. Please change your delivery date or address to see available gifts.',
};
export const FF_DELIVERY_UNAVAILABLE_PRODUCTS_MODAL = {
    modalTitle: 'Ah, we’ve hit a snag',
    productContent: 'We’re really sorry but we can’t get <span>${productName}</span> to that address on that date. How about one of these instead?',
};
export const DELIVERY_UNAVAILABLE_PRODUCTS_AVAILABLE_MODAL = {
    modalTitle: 'We can’t quite do that',
    productContent: "We're really sorry, but we can’t deliver <span>${productName}</span> to that address on that day. How about one of these instead?",
};
export const BIRTHDAY_CAMPAIGN = {
    CLAIM_BOUQUET_CTA_LINK: 'Claim your birthday bouquet',
    ALL_FLOWERS: 'All flowers',
    LOSER_TITLE: 'Sorry',
    LOSER_SUBTITLE: "You've not got a bouquet this time",
    WINNER_TITLE: 'Congratulations!',
    WINNER_SUBTITLE: "You're a winner",
    WINNER_DESCRIPTION: 'Hooray! You’ve won a bouquet worth £48.50 but you’ll pay just £1, and we’ll donate that to The Great Friendship Project. We’ve applied your discount, and we just need a few more details to finish up your order.',
    PARTICIPATION_TITLE: 'Birthday Spinning Wheel',
    FEELING_LUCKY: 'Feeling lucky?',
    PARTICIPATION_SUBTITLE: 'Spin the wheel!',
    PARTICIPATION_DESCRIPTION: 'You could nab a birthday bouquet worth £48.50 for just £1...',
    LOSER_SUBTITLE_2: "But here's a code for 15% off your next order instead.",
    LOSER_SUBTITLE_3: `Just pop the code`,
    LOSER_SUBTITLE_4: 'in at the checkout.',
    LOSER_SUBTITLE_5: "And don't forget to spin the wheel again tomorrow!",
    LOSER_URL: '/category/flower-arrangements',
    WINNER_URL: '/product/luxurious-bright-bouquet-cchtb0200s',
    WINNER_URL_PROD: '/product/luxurious-bright-bouquet-cchtb0202s',
    LOSER_FALLBACK_TEXT: 'How about looking at some lovely blooms instead?',
    FALLBACK_SUBTEXT: "We're all out of prizes",
    FALLBACK_ALL_FLOWERS: 'View all flowers',
};
export const birthdayCompetitionTermsTitle = 'Competition terms';
export const birthdayCompetitionTerms = [
    'Open to UK residents aged 18 or over only, excluding employees and their immediate families of the Promoters, its agents, associates, printers or anyone professionally connected with the promotion.',
    'The £1 birthday bouquets will be available to win every day of the week with limited numbers available each day from 09:00 GMT Friday 5th September 2025 until midnight Tuesday 30th September 2025.',
    'Entrant’s participation is via ${interflora.co.uk}/${interflora.ie} only. The Promoters cannot guarantee uninterrupted or secure access to this entry route.',
    'Entries are limited to one per person.',
    'By entering this promotion, entrants give consent to receive offers, updates and marketing from the Promoter. You can opt out at any time. We will treat your personal information with respect and use it as detailed in our ${Privacy Policy}.',
    'There will be multiple winners every week from Friday 5th September 2025 until Tuesday 30th September 2025.',
    'Each winner will be able to purchase a Luxurious Bright Bouquet, worth £48.50, for £1.',
    'Prize excludes delivery. All prizes must be collected from the local florist named in the order confirmation at no additional cost.',
    'There are no cash alternatives, the prize is not transferable or exchangeable.',
    'By entering the promotion, entrants agree to be bound by these terms and conditions and by the decisions of the Promoter that are final in all matters relating to the promotion. No correspondence will be entered into. These terms and conditions do not affect your statutory rights.',
    'The Promoter is not responsible for any problems or technical malfunction of computer on-line systems, servers, or providers, computer equipment or software, or traffic congestion on the internet, or any combination of these, including any injury or damage to entrant’s or any other person’s computer related to or resulting from participation in the promotion.',
    'This competition is run by the Promoter: Interflora British Unit, Interflora House, Watergate, Sleaford, Lincolnshire, NG34 7TB, England',
    'The Promoter reserves the right to terminate, amend or extend this promotion.',
    'Please retain these terms and conditions for future reference.',
    'Entry to this giveaway will be deemed to constitute full acceptance of these terms and conditions.',
];
export const DELIVERY_PASS_TEXTS = {
    NO_DELIVERY_PASS_TITLE: 'Want FREE delivery for a year?',
    NO_DELIVERY_PASS_DESCRIPTION_1: 'Of course you do. Enjoy unlimited free next day delivery with a delivery pass.',
    NO_DELIVERY_PASS_DESCRIPTION_2: 'Our Gold and Platinum delivery passes are our gift giving secret weapon.',
    NO_DELIVERY_PASS_CTA: 'Find out more',
    DAYS_LEFT_RENEWS_ON: 'Days left on your current pass. Renews on',
    DAYS_REMAINING: 'Days remaining.',
    EXPIRES: 'Expires',
    DAYS_REMAINING_RENEWS: 'Days remaining with current pass. Renews',
    ORDERS_PLACED_WITH_PASS: 'Orders placed with pass',
    TOTAL_SAVED_USING_PASS: 'Total saved using pass',
    RENEWAL_DESCRIPTION: 'You will be able to renew your Delivery Pass one month before expiration',
    RENEWAL_SAVINGS_DESCRIPTION: 'You can now renew your Delivery Pass to get another year of great savings.',
    RENEW_BUTTON: 'Renew',
    RENEW_DELIVERY_PASS_BUTTON: 'Renew your delivery pass',
};
export const CART_ERROR_MESSAGE = {
    modalTitle: 'We can’t quite do that',
    productContent: 'We’re currently unable to process multiple orders to the same address and date.<br><br>If you wish to send this gift (to the same address and date), first complete the order in your basket before ordering again.',
};
export const ADDRESS_LOOKUP_DATASETS = ['PAF', 'MRF', 'NYB'];
export const FAVORITES = {
    TOOLTIP_TITLE: 'Favourites',
    ARIA_LABEL_ADD: 'Add to favorites',
    ARIA_LABEL_REMOVE: 'Remove from favorites',
    INITIAL_TOOLTIP_CONTENT: 'Click the heart to\nfavourite this gift',
    FAVORITED_TOOLTIP_CONTENT: 'Find your favourites in\nthe heart icon at the\ntop-right of the screen',
};
export const FAVORITES_TEXTS = {
    HEADING: 'Favourites',
    NO_FAVORITES_TEXT_1: 'You don’t have anything saved yet.',
    NO_FAVORITES_TEXT_2: 'Just tap or click the heart icon next to any bouquet or gift to save it here.',
    FAVORITES_DESCRIPTION: 'Here’s what you like the look of.',
    ITEM_COUNT: '{totalResultsCount} items',
};
export const FAVORITES_CONFIG = {
    MAX_SKELETON_ITEMS: 12,
};
export const SIGN_IN = 'Sign in';
export const ACCOUNT = 'Account';
export const REGISTER = 'Register';
export const PROMO_APPLIED_MESSAGE = 'Promotional code applied';
export const PROMO_REMOVED_MESSAGE = 'Promotional code removed';
export const PROMO_ERROR_MESSAGE = 'There was an error removing the promotional code, please try again.';
export const PROMO_FIELD_LABEL = 'Apply a discount or promotional code';
export const PROMO_REMOVE_LINK_TEXT = 'Remove code';
export const ORDER_SUBTOTAL = 'Order subtotal:';
export const DELIVERY_CHARGE = 'Delivery charge:';
export const ORDER_TOTAL = 'Order total:';
export const PROMO_CODE = 'Promo code:';
export const PROCEED_TO_CHECKOUT = 'Proceed to checkout';
export const PROMOTIONAL_CODE_LABEL = 'Discount or promotional code';
export const PRODUCT_TYPES = {
    INTERNATIONAL: 'International',
    FUNERAL: 'Funeral',
    FLORAL: 'Floral',
    SUBSCRIPTION: 'Subscription',
    NATIONAL: 'National',
    REGIONAL: 'Regional',
    DROPSHIP: 'Dropship',
    DROPSHIP_PLANT: 'Plant Dropship',
    WITH_VARIANTS: 'with Variants',
    WITHOUT_VARIANTS: 'without Variants',
};
// Geolocation constants
export const GEOLOCATION_MESSAGES = {
    GO_TO_CURRENT_LOCATION: 'Go to current location',
    GETTING_YOUR_LOCATION: 'Getting your location...',
    UNABLE_TO_GET_LOCATION: 'Unable to get your location.',
    LOCATION_ACCESS_DENIED: 'Location access denied. Please enable location permissions.',
    LOCATION_INFORMATION_UNAVAILABLE: 'Location information is unavailable.',
    LOCATION_REQUEST_TIMED_OUT: 'Location request timed out. Please try again.',
    GEOLOCATION_NOT_SUPPORTED: 'Geolocation is not supported by this browser.',
    PERMISSIONS_API_NOT_SUPPORTED: 'Permissions API not fully supported, proceeding with geolocation request',
};
export const CONTACT_OPTION_URL_IE = 'https://www.interflora.ie/page/contact';
export const CONTACT_OPTION_URL_UK = 'https://www.interflora.co.uk/page/contact';
export const LOGO_URL_UK = 'https://media.interflora.co.uk/i/interflora/Interflora-Logo-02';
export const FILTER_MAP = 'Filter Map';
export const VIEW_EVENTS = 'View events';
export const SELECTED_FILTER_TEXT = '{selectedFilterCount} Filter';
export const STORAGE_KEYS = {
    DISCOUNT_BY_URL: 'discountByUrl',
    CTD_KEY: 'ctdKey',
};
export const CUSTOM_EVENTS = {
    DISCOUNT_REMOVED: 'discountRemoved',
    DISCOUNT_REAPPLIED: 'discountReapplied',
};
export const DISCOUNT_APPLIED_BANNER_TEXT = 'DISCOUNT CODE APPLIED - {name}';
export const DISCOUNT_SUCCESS_MODAL = {
    MESSAGE: "Hooray! Your discount will automatically be applied at the checkout, so you don't need to do anything else.",
    DEFAULT_IMAGE_URL: 'https://cdn.media.amplience.net/i/interflora/brand_imagery_AYR_expiry_September26-(17)-CROP',
    BUTTON_LABEL: 'Continue shopping',
};
export const TAKE_A_QUIZ = 'Take our quiz';
export const TAKE_A_QUIZ_FF = 'Take the quiz';
export const VAL_QUIZ_NEWS_LETTER_BUTTON_TEXT = 'Submit and get result';
export const VAL_QUIZ_NEWS_LETTER_BODY_TEXT = 'Enter your details so we can send you updates.';
export const VAL_QUIZ_NEWS_LETTER_TITLE = 'NEARLY THERE!';
export const VAL_QUIZ_SKIP_LINK_TEXT = 'Skip and get result';
export const FOUND_DUPLICATE_RECORD = 'Found Duplicate Record';
export const daysOfWeek = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
export const BADGE_VARIANTS = {
    TEXT_ONLY: 'textOnly',
    TEXT_WITH_IMAGE: 'textWithImage',
    IMAGE_ONLY: 'imageOnly',
};
export const AVAILABILITY_CHECKER_BANNER = {
    DELIVERY_DATE_PLACEHOLDER: 'When should we deliver?',
    ADDRESS_PLACEHOLDER: 'Type postcode or full address',
    OCCASION_PLACEHOLDER: "What's the occasion?",
    MORE_DATES: 'More dates',
    MORE: 'more',
    TODAY: 'Today',
    TOMORROW: 'Tomorrow',
};
export const RETURN_TO_PRODUCT = 'Return to product';
export const DELETE_REMINDER_PROCESSING_MESSAGE = 'Updates take a little time to process, so just a heads-up — you might still get an email that was already on its way.';
export const FLORIST_SPECIAL_INSTRUCTIONS_TITLE = 'Is there anything else you would like the florist to know about your gift?';
export const FLORIST_SPECIAL_INSTRUCTIONS_DESCRIPTION = `We'll pass your comments onto the florist. Every bouquet is created to order using the freshest seasonal flowers, so your florist will do their upmost to take your comments on board.`;
export const RECIPIENT_FORM_NAMES = {
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
};
export const FLORIST_INSTRUCTIONS_ARIA_LABEL = 'Special instructions for the florist';
export const FINISHING_TOUCHES_WARNING_MESSAGE = 'Choosing a new delivery date may mean some finishing touches may become unavailable. Any unavailable items will be removed from your basket.';
export const PERSONALISE_OCCASION_SUBTEXT = 'This will allow us to show you the most relevant extras!';
export const CONGRATULATORY_TEXT = 'Great choice. This will make their day.';
